<script setup lang="ts">
const { variant = "transparent" } = defineProps<{ variant?: "light" | "transparent" }>()

const route = useRoute()
const searchQuery = ref(route.query.q ?? "")

const isOnline = useOnline()

function submitSearch() {
  const q = searchQuery.value

  return navigateTo({ name: `${isOnline.value ? "search" : "search-offline"}`, query: { q } })
}
</script>

<template>
  <form
    class="flex rounded-md border-2 border-white focus-within:border-light"
    :class="{
      'bg-transparent text-white hover:border-lighter': variant === 'transparent',
      'bg-white text-darker': variant === 'light',
    }"
    role="search"
    @submit.prevent="submitSearch()"
  >
    <label class="sr-only" for="searchbar">Søk</label>
    <input
      id="searchbar"
      v-model="searchQuery"
      style="color: inherit"
      class="w-full flex-1 px-4 py-2 font-national2 focus:outline-none"
      placeholder="Søk i alt innhold"
      type="text"
      data-pendo="USearchBar-input"
    />
    <button
      class="flex-none rounded-md p-2"
      data-pendo="USearchBar-submit"
      aria-label="utfør søk"
    >
      <UIcon
        style="stroke: currentColor"
        name="search"
        size="sm"
      />
    </button>
    <p class="sr-only">
      Resultatene blir oppdatert når du klikker på søkeknappen, eller når du endrer på søkefilter.
    </p>
  </form>
</template>
